import React from 'react'
import { connect } from 'react-redux'
import { signOut } from '../../store/actions/authActions'
import { compose } from 'redux'
import { withFirebase } from 'react-redux-firebase';
import { NavLink } from 'react-router-dom'

const SignedInLink = (props) => {
  return (
    <ul>
      <li><NavLink className="sidenav-close" to="/admin/create">Create Pose</NavLink></li>
      <li><NavLink className="sidenav-close" to="/admin/poses">All Poses</NavLink></li>
      <li><NavLink className="sidenav-close" to="/user/profile">My Profile</NavLink></li>
      <li><a href='/' onClick={() => props.signOut(props.firebase)} className="sidenav-close">Log Out</a></li>
    </ul>
  )
}

const mapDispatchToProps = (dispatch) => {
  return {
    signOut: (firebase) => dispatch(signOut(firebase))
  }
}

export default compose(
  withFirebase,
  connect(null, mapDispatchToProps)
)(SignedInLink)
